/*  A Vuex module. 
*   Store for global options for the applications which comes dynamically from database
*/
const state = {
    locations : [],
    isFormModified: false,
    deployedVersion: null
};

const mutations = {
    locations: (state, val) => {
        state.locations = val;
    },
    updateForm(state) {
        state.isFormModified = true;
    },
    resetForm(state) {
        state.isFormModified = false;
    },
    deployedVersion: (state, val) => {
        state.deployedVersion = val;
    },
};

const actions = {
    locations: ({ commit }, val) => {
        commit("locations", val);
    },
    updateForm({ commit }) {
        commit('updateForm')
    },
    resetForm({ commit }) {
        commit('resetForm')
    },
    deployedVersion: ({ commit }, val) => {
        commit("deployedVersion", val);
    },
};

const getters = {
    locations: (state) => {
        return state.locations;
    },
    isFormModified: (state) => {
        return state.isFormModified;
    },
    state: (state) => {
        return {
            locations: state.locations
        };
    },
    deployedVersion: (state) => {
        return state.deployedVersion;
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};